import { useContext } from "react";

import { AuthContext } from '../context/AuthContext';

import { smartDateFormatTimestamp } from "../utils/functions";
import { db } from "../firebase";
import { collection, query, orderBy, where, getDocs, updateDoc, doc, setDoc, onSnapshot } from "firebase/firestore";

//===============================================================================
// update projects analytics in firebase (number of users and last activity)

export const UpdateAnalytics = async(projects) => {

	for(let key in projects){

		if (!projects[key]['analytics'] || !(projects[key]['analytics']['updated_1']))
		{ //analytics haven't been calculated for this project

			let analytics = await getAnalytics(projects[key]);

			console.log('update analytics ' + projects[key].name);

// 			console.log(projects[key].id);
// 			console.log(analytics);
// 			console.log({
// 				'last_activity': 	analytics['last_activity'],
// 				'users': 			analytics['users'],
// 				'user_activities': 	analytics['user_activities'],
// 				'updated': 			true,
// 			});

			projects[key]['analytics'] = analytics;
			const ref = await doc(db, "analytics", projects[key].id);
			setDoc(ref, {
				'last_activity': 	analytics['last_activity'],
				'users': 			analytics['users'],
				'user_activities': 	analytics['user_activities'],
				'updated_1': 			true,
			});

		}
	}
	return projects;
}

const getAnalytics = async(project) => {

	let result = {};
	if (project) {
		let projectID = project.id;

		const ref = collection(db, "actions");
		let q = query(ref, where('project_id', '==', projectID), orderBy('timestamp', 'desc'));
		let snap = await getDocs(q);
		let analytics = snap.docs.map((doc) => ({ ...doc.data()}));

		var max = 0;
		for (let key in analytics) {

			let item = analytics[key];
			if (item.timestamp > max) {
				max = item.timestamp;
			}
		}

		if (max > 0)
			result['last_activity'] = max;
		else
			result['last_activity'] = false;

		result['user_activities'] = analytics.length;


		result['users'] = [];
		//if (project.creation_date < new Date("2024-06-01").getTime()) {

		let users = []
		q = query(collection(db, "users"), orderBy("score", "desc"));
		snap = await getDocs(q);
		let items = snap.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
		for (let key in items){
			if (items[key].progress && project['id'] && items[key].progress[project['id']]){
				users.push(items[key]['id']);
			}
		}
		result['users'] = users;

		/*
		} else {

			let users = new Set();
			for (let key in analytics) {
				let item = analytics[key];
				users.add(item.user_id);
			}
			result['users'] = Array.from(users);
		}
		*/

		return result;
	}
}
